import { createFileRoute, Link } from '@tanstack/react-router';
import { Stack, Breadcrumbs } from '@mui/joy';
import { ShipmentForm } from '@/components/Pages/Shipments/ShipmentForm';

export const Route = createFileRoute('/_protected/shipments/create')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Stack direction='row' justifyContent='space-between'>
        <Breadcrumbs size='sm'>
          <Link to='/shipments'>Envíos</Link>
        </Breadcrumbs>
      </Stack>

      <ShipmentForm />
    </>
  );
}
